import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { SemesterService } from '@app/_services/masters/semester.service';
import { semester } from '@app/_models/semester';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-semester-master-edit',
  templateUrl: './semester-master-edit.component.html',
  styleUrls: ['./semester-master-edit.component.css']
})
export class SemesterMasterEditComponent implements OnInit {
  SemId: number;
  editSemesterForm: FormGroup;
  semester: semester[];
  submitted = false;
  semesterName: string;
  response: any;
  semesterId: number;
  getresponse: any;
  strMessage: string;
  streamDropDown = [];
  streamId: number;

  get f() { return this.editSemesterForm.controls; }

  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private semesterService: SemesterService,
    private modalService: NgbModal, private verifyDocService: VerifyDocumentService, config: NgbModalConfig) { }

  @Input() childMessage: semester[];

  receiveDocumentId(p) {
    this.SemId = p;
  }

  ngOnInit(): void {

    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;
    this.semesterName = this.response.semester;
    this.semesterId = this.response.id;
    this.streamId = this.response.streamId;

    this.editSemesterForm = this.formBuilder.group({
      semesterName: ['', Validators.required],
      streamId: ['', Validators.required]
    });

    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }

  updateSemester() {
    this.submitted = true;

    if (this.editSemesterForm.invalid) {
      return;
    }
    var v = new semester();
    v.semestername = this.semesterName;
    v.id = this.semesterId;
    v.streamid = this.streamId;
    this.semesterService.updateSemester(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.strMessage = "Semester Updated Successfully.";
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }

          else if (this.getresponse.respMessage == "Failure") {
            this.strMessage = this.getresponse.respData;
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('21');
  }

  goBack() {
    this.eventService.emit<string>('21');
  }
}

